import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  pageNotFoundPage: {
    padding: '16px 24px 16px 24px',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    '@media (max-width: 640px)': {
      padding: '0px',
    },
  },
  pageNotFoundPageItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
  },
  pageNotFoundPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '81px 0px 81px 0px',
    gap: '27px',
    '@media (max-width: 1024px)': {
      padding: '24px 0px 81px 0px',
      gap: '24px',
    },
  },
  status: {
    color: theme.evPalette.ocean[700],
    fontFamily: 'Noto Sans',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '54px',
    textTransform: 'capitalize',
  },
  pageNotFound: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '42px',
    textTransform: 'capitalize',
  },
  statusMessage: {
    color: theme.evPalette.charcoal[900],
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
  },
  redirectionPageImage: {
    display: 'flex',
    justifySelf: 'center',
    maxWidth: '82vw',
    '@media (max-width: 1024px)': {
      height: '234px',
    },
  },
}));
